//⚠️IMPACT attention changer dans le fichier prisma l'enum PulseTextKind (mêmes valeurs, même ordre)
import { validateEnumTranslations } from '../../safety_checks';

/**
 * Textes que Pulse rédige pendant le tunnel (onboarding v4, lot 5, spec section H) et qu'il
 * versionne dans `pro_generated_text` : le pro relit, demande « une autre » ou garde.
 * - `SERVICE_DESCRIPTION` : description d'une prestation (`target_id` = prestation) ;
 * - `TAGLINE` : accroche du site, une phrase ;
 * - `ABOUT` : page « à propos », depuis `professional.about_raw` ;
 * - `GMB_DESCRIPTION` : description de la fiche Google (750 caractères au plus) ;
 * - `SHARE_MESSAGE` : message de partage du lien de réservation.
 */
export enum PulseTextKind {
  SERVICE_DESCRIPTION = 'SERVICE_DESCRIPTION',
  TAGLINE = 'TAGLINE',
  ABOUT = 'ABOUT',
  GMB_DESCRIPTION = 'GMB_DESCRIPTION',
  SHARE_MESSAGE = 'SHARE_MESSAGE',
}

export const TRANSLATE_KEY_PULSE_TEXT_KIND = 'PULSE_TEXT_KIND_';

/** Libellés de l'encart « Pendant qu'on parle, Pulse rédige » (écran 10) et de l'écran 11 bis. */
export const PulseTextKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PULSE_TEXT_KIND}${PulseTextKind.SERVICE_DESCRIPTION}`]: 'Description de chaque prestation',
    [`${TRANSLATE_KEY_PULSE_TEXT_KIND}${PulseTextKind.TAGLINE}`]: 'Accroche du site',
    [`${TRANSLATE_KEY_PULSE_TEXT_KIND}${PulseTextKind.ABOUT}`]: 'Page « à propos »',
    [`${TRANSLATE_KEY_PULSE_TEXT_KIND}${PulseTextKind.GMB_DESCRIPTION}`]: 'Description de la fiche Google',
    [`${TRANSLATE_KEY_PULSE_TEXT_KIND}${PulseTextKind.SHARE_MESSAGE}`]: 'Message de partage du lien',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(PulseTextKind, PulseTextKindTranslation, TRANSLATE_KEY_PULSE_TEXT_KIND, true);
